import React from 'react';
import { IntegrationsPageLayout } from 'components/Integrations/components/IntegrationsPageLayout';

export const AdobeIntegrationConfig = () => {
  console.log('TODO: Determine activation status');
  return (
    <IntegrationsPageLayout
      pageTitle="Adobe Integration"
      breadcrumbs={[{ label: 'Adobe', path: '/adobe' }]}
    >
      TODO: Adobe Integration Module
    </IntegrationsPageLayout>
  );
};
